
import { mapGetters, mapActions } from 'vuex'
import { footer } from '../customWhiteLabel'

export default {
  data() {
    return {
      dialog: false,
      form: {
        cpf_cnpj: '',
        endereco: {},
        cnaes_principal: {},
      },
      itemsCPF: [
        { title: 'Score' },
        { title: 'Dados cadastrais' },
        { title: 'Dados restritivos' },
        { title: 'Renda presumida' },
        { title: 'Indicador de decisão' },
        { title: 'Limite de parcela sugerida' },
        { title: 'E muito mais.' },
      ],
      itemsCNPJ: [
        { title: 'Score' },
        { title: 'Dados cadastrais' },
        { title: 'Dados restritivos' },
        { title: 'Indicadores positivos' },
        { title: 'Quadro societário' },
        { title: 'Limite de crédito' },
        { title: 'E muito mais.' },
      ],
      loadingAndDisabledSolicitante: false,
    }
  },
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
  },
  methods: {
    ...mapActions('solicitacao-sdc', ['createSolicitacaoCompany']),

    async handlerCreateSolicitacao() {
      const formValidate = this.$refs.formSolicitacao.validate()
      if (!formValidate) {
        return false
      }

      /* eslint-disable camelcase */
      const { cpf_cnpj, telefone_contato, ...remainingData } = this.form
      const cpfCnpj = cpf_cnpj.replace(/\D/g, '')
      const telefoneContatoSemCaracteres = telefone_contato.replace(/\D/g, '')

      const payload = {
        responsavel: {
          cpf_cnpj: this.unidadeInformation.cpfcnpj,
          unidade: this.unidadeInformation.unidade,
        },
        cpf_cnpj: cpfCnpj,
        telefone_contato: telefoneContatoSemCaracteres,
        ...remainingData,
      }

      this.loadingAndDisabledSolicitante = true
      try {
        await this.createSolicitacaoCompany(payload)
        this.$toast.success('Solicitado com sucesso')
        this.dialog = false
        this.$refs.formSolicitacao.resetValidation()
        this.form = {
          cpf_cnpj: '',
          endereco: {},
          cnaes_principal: {},
        }
      } catch (error) {
        console.error(error)
        this.$toast.error('Houve algum erro: ' + error)
      } finally {
        this.loadingAndDisabledSolicitante = false
      }
    },

    sendMessage() {
      const phoneNumber = footer.comercial.replace(/\D/g, '')
      const urlMessage = window.location.origin.replace(/^https?:\/\//, '')
      const message = `Olá, estou no site ${urlMessage} e gostaria de saber mais sobre o SD Consulta`
      const whatsappUrl = `https://wa.me/55${phoneNumber}?text=${encodeURIComponent(
        message
      )}`
      window.open(whatsappUrl, '_blank')
    },
  },
}
